import { useLocation } from "react-router-dom";

const NavMenuItem = ({label, url, img, onClick, disabled}) => {
  const location = useLocation();
  const class2 = location.pathname === url ? ' nav-menu-item-selected' : ''

  if (disabled)
    return <div className={"nav-menu-item" + class2} >
      <div className="nav-menu-indicator"/>
      <img src={`/images/${img}`} className="menu-img" alt="menu-img"/>
      <div>{label}</div>
    </div>

  if (onClick)
      return <div className="nav-menu-item" onClick={onClick} style={{cursor: "pointer"}}>
        <img src={`/images/${img}`} className="menu-img" alt="menu-img"/>
        <div>{label}</div>
      </div>

  return <a href={url} className={"nav-menu-item" + class2} >
    <div className="nav-menu-indicator"/>
    <img src={`/images/${img}`} className="menu-img" alt="menu-img"/>
    <div>{label}</div>
  </a>
}

export default NavMenuItem;